import { API_endpoints } from "../config";

export const statistic10 = async (): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic10, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 10 Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von statistik 10 Daten:", error);
    }
};
